import React, {createContext, ReactNode, useContext, useState} from 'react';

type GlobalContext = {
  isGlassTheme: boolean
  handleGlassTheme: () => void
}

interface GlobalProviderProps {
  children: ReactNode;
}

const defaultContext = {
  isGlassTheme: true,
  handleGlassTheme: () => {}
};

const GlobalContext = createContext<GlobalContext>(defaultContext);

export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalProvider = ({children}: GlobalProviderProps) => {
  const [isGlassTheme, setIsGlassTheme] = useState(
    localStorage.getItem('isGlassTheme') === 'true'
  );
  const handleGlassTheme = () => {
    setIsGlassTheme(prev => {
      const newValue = !prev;
      localStorage.setItem('isGlassTheme', String(newValue));
      return newValue;
    });
  };

  return (
    <GlobalContext.Provider value={{isGlassTheme, handleGlassTheme}}>
      {children}
    </GlobalContext.Provider>
  );
};